import { Page, Container, ContentHeader } from 'components'
import { ProfilesForm } from 'components/Profiles'

import constants from 'constants/index'

const CollaboratorProfilesNew = () => {
  return (
    <Page title="Novo perfil de colaborador">
      <Container
        maxWidth={false}
        spacingXl={30}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader
          title="Novo"
          menu="Perfis de colaborador"
          subtitle="Novo perfil de colaborador"
        />
        <ProfilesForm profileType={constants.user.PROFILE_TYPE_COLLABORATOR} />
      </Container>
    </Page>
  )
}

export default CollaboratorProfilesNew
